import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    margin: {
        marginTop: 50,
    },
}));


export default function Copyright() {

    const classes = useStyles();


    return (
        <Typography variant="body2" color="textSecondary" align="center" className={classes.margin}>
            {'Copyright © '}
            {new Date().getFullYear()}{'. '}
            <Link color="inherit" href="https://material-ui.com/">
                Mini Systems
            </Link>
            {'. All rights reserved '}
        </Typography>
    );
}


// WEBPACK FOOTER //
// ./src/components/Copyright.js